export default {
  countryZones: [],
  activeCountryZone: null,
  activeInCountryZone: null,
  inCountryZones: [],
  isZoneManagerPanelOpen: false,
  currentDivision: null,
}
